import { useEffect } from 'react';
const PIXEL_ID = '1382165483456185';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}

/**
 * Meta Pixel base code. Loads fbevents.js and fires the initial PageView.
 */
export function MetaPixel() {
  useEffect(() => {
    const f = window as Window & typeof globalThis;
    if (f.fbq) return;
    const n: any = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    f.fbq = n;
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-38" data-mp="18huldhp2n27j">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-39" data-mp="13gopxc4110ub" />
    </noscript>;
}